// removed by extract-text-webpack-plugin
module.exports = {"socialButtons":"styles__socialButtons___1ISJg","filterSocialButtons":"styles__filterSocialButtons___3NF3-","filters":"styles__filters___3_kIu","btn":"styles__btn___2dvNx","togglePastStoriesBtn":"styles__togglePastStoriesBtn___1ZFJj","eventDate":"styles__eventDate___1DGj2","rotate":"styles__rotate___PVf-3","fadein":"styles__fadein___3QMpv","slideFromRight":"styles__slideFromRight___1NuSv","waves":"styles__waves___2Hd85"};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/containers/NewsEvents/styles.scss
// module id = ./resources/assets/js/containers/NewsEvents/styles.scss
// module chunks = 0